import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_delete",
  "use": "icon-map_delete-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_delete\">\n<g id=\"icon-map_delete_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 0 2 C 1.320313 5.441406 0.90625 11.714844 3 14.398438 C 11.25 24.777344 15.21875 6.203125 16 2 C 9.859375 1.21875 6.199219 1.242188 0 2 M 9 1 L 8 2 L 9 1 M 4.601563 4.601563 C 11.675781 0.472656 16.761719 11.441406 10.683594 14.394531 C 4.515625 17.394531 -0.378906 7.511719 4.601563 4.601563 M 7 5 L 7 12 L 9 12 L 9 5 L 7 5 M 4 6 C 4 8.203125 4.355469 10 5 12 L 6 12 L 6 6 L 4 6 M 10 6 L 10 12 L 11 12 C 11.644531 10 11.90625 8.203125 12 6 L 10 6 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_delete.svg
// module id = 26KQ
// module chunks = 24